<template>
  <div>
    <v-sheet
      v-if="listLoading"
      class="d-flex flex-column justify-center"
      min-height="200px"
    >
      <div
        class="mx-auto"
      >
        <v-progress-circular
          :size="40"
          color="primary"
          indeterminate
        />
      </div>
    </v-sheet>

    <RevisionList
      v-else
      :revisions="revisions"
      @revision-click="onRevisionClick"
    />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useAppLoading } from '@/stores/app/loading';
import { useAppRoute } from '@/stores/app/route';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import RevisionList from '@ui/components/editor/RevisionList/RevisionList.vue';

const { revisions, isHrisProfile } = storeToRefs(useCurrentJobProfile());
const { listLoading } = storeToRefs(useAppLoading());
const { route } = storeToRefs(useAppRoute());
const router = useRouter();
const { jobProfile } = storeToRefs(useCurrentJobProfile());

const load = () => {
  if (isHrisProfile.value || jobProfile.value?.last_revision_ulid) {
    useCurrentJobProfile().loadRevisions();
  }
};

onMounted(() => load());

watch([
  () => jobProfile.value?.last_revision_ulid,
  () => jobProfile.value?.finalized_revision_ulid,
  isHrisProfile,
], () => {
  load();
});

const onRevisionClick = ({ revision }) => {
  router.push({ query: { ...route.value?.query, sideRevision: revision.ulid } });
};
</script>

<style lang="less" scoped>
.revision-list :deep(.revision-item) {
  .timeline-line {
    height: 100px;
  }
  &:first-child .timeline-line {
    height: 75px;
  }
  &:last-child .timeline-line {
    height: 75px;
  }
}
</style>
